import React from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import store from 'store'
import makeAuthenticate from './interceptors/authenticate'
import analytics from 'misc/analytics'
import makeTrackReferrerMeta from './interceptors/trackReferrerMeta'

import App from '../App'
import Login from 'screens/Login'
import Projects from 'screens/Projects'
import ProjectDetails from 'screens/ProjectDetails'
import ProjectWizard from 'screens/ProjectWizard'
import RateProject from 'screens/RateProject'
import LinkedAccounts from 'screens/LinkedAccounts'
import ReferAFriend from 'screens/ReferAFriend'
import Coupons from 'screens/Coupons'
import Documents from 'screens/Documents'
import Profile from 'screens/Profile'
import Billing from 'screens/Billing'
import Sweepstakes, { sweepstakes } from 'screens/Sweepstakes'

const authenticate = makeAuthenticate({ authStore: store.authStore })
const trackReferrerMeta = makeTrackReferrerMeta({ authStore: store.authStore })

const createElement = (Component, props) => <Component {...props} rootStore={store} />

const onRouterUpdate = () => {
  analytics.page()
}

const AppRouter = () => (
  <Router history={browserHistory} createElement={createElement} onUpdate={onRouterUpdate}>
    <Route onEnter={trackReferrerMeta}>
      <Route path="/login" component={Login} />
      {sweepstakes.map(item =>
        <Route component={Sweepstakes} key={item.path} {...item} />
      )}
      <Route path='/' component={App} onEnter={authenticate}>
        <IndexRoute component={Projects} />
        <Route path="linked-accounts" component={LinkedAccounts} />
        <Route path="documents" component={Documents} />
        <Route path="coupons" component={Coupons} />
        <Route path="billing" component={Billing} />
        <Route path="profile" component={Profile} />
        <Route path="refer" component={ReferAFriend} />
        <Route path="new" component={ProjectWizard} />
        <Route path="project/:id" component={ProjectDetails} />
        <Route path="project/:id/rate" component={RateProject} />
        <Route path="project/:id/edit" component={ProjectWizard} />
      </Route>
    </Route>
  </Router>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/client/shell/AppRouter/index.jsx